const numFmt = new Intl.NumberFormat('es-ES');
const eurFmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });

export const fmtNum = (n: number | null | undefined): string =>
  n == null ? '—' : numFmt.format(n);

export const fmtEur = (n: number | null | undefined): string =>
  n == null ? '—' : eurFmt.format(n);
